import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const HowItWorks = ({ headingLevel = 'h2' }) => {
  const { t, isRTL } = useLanguage();
  const steps = t('howItWorks.steps');
  const HeadingTag = headingLevel;

  return (
    <section
      id="how-it-works"
      className="relative bg-black py-24 md:py-32"
      style={{ direction: isRTL ? 'rtl' : 'ltr' }}
    >
      {/* Subtle Grid */}
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)
          `,
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-5 md:px-[7.6923%]">
        {/* Section Title */}
        <div className="text-center mb-16 md:mb-24">
          <HeadingTag className="text-4xl md:text-5xl lg:text-[48px] font-semibold text-white leading-[1.1] tracking-[-0.02em]">
            {t('howItWorks.title')}
          </HeadingTag>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {Array.isArray(steps) &&
            steps.map((step, index) => (
              <div
                key={index}
                className="group relative glass-card p-8 md:p-10"
              >
                {/* Step Number */}
                <div
                  className={`absolute -top-6 bg-black px-4 rounded-lg ${
                    isRTL ? 'right-8' : 'left-8'
                  }`}
                >
                  <span className="text-[#00FFD1] text-5xl md:text-6xl font-bold opacity-30 group-hover:opacity-100 transition-opacity duration-400">
                    {step.number}
                  </span>
                </div>

                {/* Content */}
                <div className="pt-8">
                  <h3 className="text-2xl md:text-[28px] font-semibold text-white mb-4 leading-[1.2]">
                    {step.title}
                  </h3>
                  <p className="text-white/60 text-lg leading-relaxed">
                    {step.desc}
                  </p>
                </div>

                {/* Connection Line */}
                {index < steps.length - 1 && (
                  <div
                    className={`hidden md:block absolute top-1/2 h-[2px] w-12 bg-gradient-to-r from-[#00FFD1]/50 to-transparent ${
                      isRTL ? 'left-0 -translate-x-full rotate-180' : 'right-0 translate-x-full'
                    }`}
                  />
                )}
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
